<!--面板组件-->

<template>
  <div class="outest">
    <!-- 只有一列 -->
    <div class="outsideBox2" v-if="series == 1">
      <div v-for="item in formdata.left || formdata" :key="item.id">
        <div v-if="item.type == 'nomal'" class="itms">
          <div class="lContent">{{ item.name }}</div>
          <div class="type1">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'title'" class="itms">
          <div class="title">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'wrap'" class="itms2">
          <div class="lContent">{{ item.name }}</div>
          <div class="type1 type2">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <!-- 有两列 -->
    <div v-if="series == 2">
      <div class="outsideBox3">
        <div class="itemBox box_line">
          <div class="itms">
            <div class="title" style="margin-top: 0;">{{ formdata.selfie.title }}</div>
          </div>
          <div class="itms2 row">
            <div class="lContent">{{ formdata.selfie.name }}</div>
            <div>
              <img class="type3 img" v-if="formdata.selfie.imgurl && !formdata.selfie.imgurl.includes('.pdf')" :src="formdata.selfie.imgurl" />
              <div v-else class="file-wrap">
                <div class="file" @click.stop="openFile(formdata.selfie.imgurl)">
                  {{ getFileName(formdata.selfie.imgurl) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="itemBox box_line box_mar_top" v-if="formdata.certificate && formdata.certificate.title">
          <div class="itms">
            <div class="title">{{ formdata.certificate.title }}</div>
          </div>
          <div class="itms2 row">
            <div class="lContent">{{ formdata.certificate.name }}</div>
            <div class="file-wrap">
              <div class="file" v-for="item in displayCertificateImgList" :key="item.index" @click.stop="openFile(item)">
                {{ getFileName(item) }}
              </div>
              <div v-if="certificateImg && certificateImg.length > 10 && !isShowMoreFile" class="show-more" @click="showMorefile">Show More ({{certificateImg.length - 10}})</div>
            </div>
          </div>
        </div>
      </div>
      <div class="outsideBox3 box_mar_top">
        <div class="itemBox">
          <div class="itms">
            <div class="title">{{ formdata.exterior.title }}</div>
          </div>
          <div class="itms2 row">
            <div class="lContent">{{ formdata.exterior.name }}</div>
            <div class="file-wrap">
              <div class="file" v-for="item in formdata.exterior.imgurl" :key="item.index" @click.stop="openFile(item)">
                {{ getFileName(item) }}
              </div>
            </div>
          </div>
        </div>
        <div class="itemBox" style="padding-bottom: 0;">
          <div class="itms2 row">
            <div class="lContent">{{ formdata.interior.name }}</div>
            <div class="file-wrap">
              <div class="file" v-for="item in formdata.interior.imgurl" :key="item.index" @click.stop="openFile(item)">
                {{ getFileName(item) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 有三列 -->
    <!-- 左 -->
    <div class="outsideBox" v-if="series == 3">
      <div v-for="item in formdata.left" :key="item.id">
        <div v-if="item.type == 'title'" class="itms">
          <div class="title">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'nomal'" class="itms">
          <div class="lContent">{{ item.name }}</div>
          <div class="type1">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'wrap'" class="itms2">
          <div class="lContent">{{ item.name }}</div>
          <div class="type1 type2">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'documents'" class="itms">
          <div class="lContent"></div>
          <div class="type1"><a @click="openDialogB">Data Privacy</a></div>
        </div>
        <div v-if="item.type == 'documents'" class="itms">
          <div  class="lContent">Signed Documents</div>
          <div class="type1">
            <a @click="openDialogA">Merchant Agreement</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 中 -->
    <div class="outsideBox" v-if="series == 3">
      <div v-for="item in formdata.middle" :key="item.id">
        <div v-if="item.type == 'title'" class="itms">
          <div class="title">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'nomal'" class="itms">
          <div class="lContent">{{ item.name }}</div>
          <div class="type1">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'wrap'" class="itms2">
          <div class="lContent">{{ item.name }}</div>
          <div class="type1 type2">{{ item.value }}</div>
        </div>
      </div>
    </div>
    <!-- 右 -->
    <div class="outsideBox" v-if="series == 3">
      <div v-for="item in formdata.right" :key="item.id">
        <div v-if="item.type == 'nomal'" class="itms">
          <div class="lContent">{{ item.name }}</div>
          <div class="type1">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'title'" class="itms">
          <div class="title">{{ item.value }}</div>
        </div>
        <div v-if="item.type == 'wrap'" class="itms2">
          <div class="lContent">{{ item.name }}</div>
          <div class="type1 type2">{{ item.value }}</div>
        </div>
      </div>
    </div>
    <DialogV1
      v-if="showDialog"
      @closeDialog="closeDialog"
      @doAgree="doAgree"
      :needDisagree="false"
      :btn_name="'I Agree'"
    >
      <template v-slot:dia-content-title>{{ dialogTitle }}</template>
      <template v-slot:dia-content-solt>
        <div class="agree-body">
          <div v-if="dialogTitle == 'MERCHANT AGREEMENT'">
            <!-- <div v-for="(item,index) in agreeContent" :key="index" class="agreeBoxImg">
            <img :src="item" />
          </div> -->

            <div v-html="merchantAgreement"></div>
            <div class="data-time" v-if="agreements && agreements.newMchNameAgreement">
              <p v-if="showRegisteredBusinessName">Registered Business Name: {{agreements ? agreements.registeredBusinessName : ''}}</p>
              <p>{{ showRegisteredBusinessName ? 'Represented by' : 'Name' }}: {{agreements ? agreements.newMchNameAgreement : ''}}</p>
              <p>Date&Time: {{agreements ? agreements.merchantAgreementTime : ''}}</p>
            </div>
          </div>
          <div v-else>
            <div v-html="privacy"></div>
            <div class="data-time" v-if="agreements && agreements.newMchNameAgreement">
              <p v-if="showRegisteredBusinessName">Registered Business Name: {{agreements ? agreements.registeredBusinessName : ''}}</p>
              <p>{{ showRegisteredBusinessName ? 'Represented by' : 'Name' }}: {{agreements ? agreements.newMchNameAgreement : ''}}</p>
              <p>Date&Time: {{agreements ? agreements.privacyAgreementTime : ''}}</p>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:dia-content-cbc>
        I have read,understood and agree to the
        <strong>{{ dialogTitle }}</strong> declared herein</template
      >
    </DialogV1>
  </div>
</template>


<script>
import DialogV1 from "../components/DialogV1";
import { privacy } from "../../common-data/privacy-policy";
import { merchantAgreement } from "../../common-data/merchant-agreement";
export default {
  name: "InfoBox",
  components: {
    DialogV1,
  },
  computed: {
    certificateImg() {
      if(Array.isArray(this.formdata.certificate.imgurl)) {
        return this.formdata.certificate;
      }
      return this.formdata.certificate.imgurl ? this.formdata.certificate.imgurl.split(',') : [];
    },
    displayCertificateImgList() {
      return this.isShowMoreFile ? this.certificateImg : this.certificateImg.slice(0, 10);
    },
    showRegisteredBusinessName() {
      const { processNo } = this.agreements;
      return this.agreements && (processNo == '3' || processNo == '4');
    }
  },
  data() {
    return {
      dialogTitle: "",
      showDialog: false,
      showModal: false,
      privacy: privacy,
      merchantAgreement: merchantAgreement,
      pdfSrc: '',
      showViewDialog: false,
      isShowMoreFile: false,
    };
  },
  props: ["formdata", "series", "agreements"],
  methods: {
    showMorefile() {
      this.isShowMoreFile = true;
    },
    openDialogA() {
      this.showDialog = true;
      this.dialogTitle = "MERCHANT AGREEMENT";
    },
    openDialogB() {
      this.showDialog = true;
      this.dialogTitle = "Privacy Policy";
    },
    doConfirm() {
      this.showModal = false;
    },
    toBack() {
      this.showDialog = true;
      this.showModal = false;
    },
    doAgree() {
      this.showDialog = false;
    },
    closeDialog() {
      this.showDialog = false;
    },
    showPdf(src) {
        this.pdfSrc = src
        this.showViewDialog = true;
    },
    closeViewDialog() {
      this.showViewDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.outest {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.outsideBox {
  width: 320px;
  // display: flex;
  // flex-direction: column;
}
.outsideBox2 {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.outsideBox3 {
  width: 100%;
  // height: 264px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .title {
    font: normal normal normal 16px/22px Nunito-bold;
    color: #004EA8;
    margin: 20px 0 10px;
  }
  .itemBox {
    // height: 230px;
    width: 480px;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    .lContent{
      color: #2E2E2E;
    }
    .file-wrap {
      .file {
        font: normal normal normal 16px/22px Nunito-bold;
        color: #0072D8;
        word-break: break-all;
        text-decoration: underline;
        margin-bottom: 16px;
        text-align: right;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .show-more {
        border-radius: 6px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font: normal normal normal 14px/24px Nunito-bold;
        color: #0072D8;
        cursor: pointer;
        margin-bottom: 8px;
        background-color: #E5F1FF;
        padding: 8px 0;
        box-sizing: border-box;
      }
    }
    .img {
      width: 230px;
      height: 156px;
      margin-top: 0;
    }
  }
}
.box_line {
  border-bottom: 1px solid #e4e4e4;
}
.box_mar_top {
  margin-top: 10px;
}
.itms {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 12px;
}
.itms2 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 12px;
  &.row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.itms3 {
  width: 230px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 12px;
}
.title {
  color: #656565;
  font-size: 16px;
  height: 22px;
  // font-weight: 600;
}
.lContent {
  min-width: 132px;
  // min-width: 175px;
  color: #919191;
  line-height: 19px;
}
.type1 {
  color: #2e2e2e;
  // font-weight: 600;
  font-family: Nunito-bold;
  font-size: 14px;
  text-align: right;
  word-break:break-all;
  // word-break: break-all  ;
  // word-break: normal  ;
}
.type2 {
  width: 400px;
  text-align: left;
}
.type3 {
  margin-top: 7px;
  width: 230px;
  height: 180px;
  border-radius: 3px;
}
a {
  color: #0072d8;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
}
.agreeBoxImg {
  width: 100%;
  img {
    width: 100%;
  }
}

.agree-body {
  word-break: break-word;
  ::v-deep {
    p {
      margin-bottom: 10px;
    }
  }
}

.data-time{
  padding-top: 20px;
}
</style>
